var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_5116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4004 4.90029L5.51143 4.91205V1.0996C5.51143 0.767416 5.24401 0.5 4.91182 0.5C4.57974 0.5 4.31222 0.767416 4.31222 1.0996L4.32398 4.9004H0.599602C0.267416 4.9004 0 5.16781 0 5.5C0 5.83208 0.267416 6.0995 0.599602 6.0995H4.3181V9.9004C4.3181 10.2324 4.58552 10.5 4.9177 10.5C5.24989 10.5 5.5173 10.2324 5.5173 9.9004V6.0996H9.4004C9.73258 6.0996 10 5.83197 10 5.5C10 5.16771 9.72959 4.90029 9.4004 4.90029Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_5116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "none",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.53ebc534b0817a3d04d99717eb2d728a.svg";
export { ForwardRef as ReactComponent };